import MiLanguageManagement from './language';
import { install } from '../../../utils/install';
export default install(MiLanguageManagement);
